import { getQueryClient } from '@/lib/query/client/query-client';
import { useMutation } from '@tanstack/react-query';

import { shelvesApi } from './shelves.api';
import { shelfKeys } from './shelves.queries';
import type { CreateShelfRequest, UpdateShelfRequest } from '../types';

export const useCreateShelf = () => {
  return useMutation({
    mutationFn: (data: CreateShelfRequest) => shelvesApi.create(data),
    meta: {
      operationType: 'create',
      fallbackSuccessMessage: 'shelves.createSuccess'
    },
    onSuccess: () => {
      getQueryClient().invalidateQueries({ queryKey: shelfKeys.lists() });
      getQueryClient().invalidateQueries({ queryKey: shelfKeys.stats() });
    }
  });
};

export const useUpdateShelf = () => {
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: UpdateShelfRequest }) =>
      shelvesApi.update(id, data),
    meta: {
      operationType: 'update',
      fallbackSuccessMessage: 'shelves.updateSuccess'
    },
    onSuccess: () => {
      getQueryClient().invalidateQueries({ queryKey: shelfKeys.lists() });
    }
  });
};

export const useDeleteShelf = () => {
  return useMutation({
    mutationFn: (id: number) => shelvesApi.delete(id),
    meta: {
      operationType: 'delete',
      fallbackSuccessMessage: 'shelves.deleteSuccess'
    },
    onSuccess: () => {
      getQueryClient().invalidateQueries({ queryKey: shelfKeys.lists() });
      getQueryClient().invalidateQueries({ queryKey: shelfKeys.stats() });
    }
  });
};
